const public_api_url = process.env.REACT_APP_API_URL;

export const getDisciplines = () => {
  return fetch(public_api_url+"/api/activities/disciplines/total")
    .then(res => res.json() )
}
export const getCurrentDisciplines = () => {
  return fetch(public_api_url+"/api/activities/disciplines/current")
    .then(res => res.json() )
}
export const getThisMonthDisciplines = () => {
  const year = new Date().getFullYear();
  const month = new Date().getMonth()+1;
  return fetch(`${public_api_url}/api/activities/disciplines/${year}/${month}`)
    .then(res => res.json() )
}
export const getPreviousMonthDisciplines = () => {
  const previousMonthDate = new Date().setMonth(new Date().getMonth() - 1);
  const year = new Date(previousMonthDate).getFullYear();
  const month = new Date(previousMonthDate).getMonth()+1;
  return fetch(`${public_api_url}/api/activities/disciplines/${year}/${month}`)
    .then(res => res.json() )
}



// WEBPACK FOOTER //
// ./src/api/public/disciplines.js